"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatDisplayAmount = void 0;
/**
 * Formats a given DisplayAmount object into a human-readable string according to the following rules:
 * - If the `displayUnit` is a percentage ("%"), it formats the value as a percentage, e.g., "10%" or "-10%".
 * - If the `displaySymbol` is not defined, it formats the value with the `displayUnit`, e.g., "10 dollars" or "-10 euros".
 * - If the `displaySymbol` is defined, it formats the value with the symbol, e.g., "$10" or "-€10".
 *
 * The formatting accounts for negative values, prepending a "-" sign as needed.
 *
 * @param amount - The DisplayAmount object containing various properties to represent the amount.
 * @returns The formatted string representing the amount.
 */
const formatDisplayAmount = (amount, hideUnit) => {
    const sign = amount.negative ? "-" : "";
    const value = amount.displayValue;
    const isPercentage = amount.displayUnit === "%";
    if (isPercentage) {
        return `${sign}${value}${amount.displayUnit}`;
    }
    // handle points
    if (!amount.displaySymbol) {
        if (hideUnit || !amount.displayUnit) {
            return `${sign}${value}`;
        }
        return `${sign}${value} ${amount.displayUnit}`;
    }
    // handle dollars
    return `${sign}${amount.displaySymbol}${value}`;
};
exports.formatDisplayAmount = formatDisplayAmount;
